import { RootState } from './store'

/**
 * select info about discount
 */
export const selectDiscountInfo = (state: RootState) => {
  const {
    displayDiscount,
    discountIsPercentage,
    totals: { maxSaleDiscount },
  } = state.currentSale
  return {
    displayDiscount,
    discountIsPercentage,
    maxSaleDiscount,
  }
}

/**
 * select sale discount
 */
export const selectSaleDiscount = (state: RootState) =>
  state.currentSale.discount

/**
 * Selects the LSPay cash discount percentage from the sale-level configuration
 * field (`lspCashDiscountPercentage`). This represents the potential/preview
 * rate fetched from the outlet settings and is available as soon as the hook
 * resolves — independently of whether the discount has been applied to the
 * sale totals yet.
 *
 * Use `state.currentSale.totals.lspCashDiscount`
 * when you need to know whether the discount was actually applied and recorded.
 */
export const selectLspCashDiscountPercentage = (state: RootState) =>
  Number(state.currentSale.lspCashDiscountPercentage ?? 0)

/**
 * select sale return for
 */
export const selectSaleReturnFor = (state: RootState) =>
  state.currentSale.returnFor
